<nav class="tw-reset tw-overflow-x-auto tw-overflow-y-hidden tw-p-1" #tabBar>
  <ul
    role="tablist"
    class="tw-flex tw-whitespace-nowrap tw-border-b tw-border-neutral-300 tw-text-neutral-600"
  >
    @for (tab of configuration().tabs; track tab.name; let i = $index) {
      <li>
        <button
          #tabButton
          type="button"
          [attr.aria-selected]="tab.id === activeTab().id"
          role="tab"
          tabindex="0"
          (keydown)="handleKeydown($event, i)"
          [class]="
            twJoin(
              'tw-flex tw-items-center tw-border-b-2 tw-py-2 tw-pl-2 tw-pr-6 tw-font-semibold',
              tab.id === activeTab().id
                ? '-tw-mb-px tw-border-blue-800 tw-text-blue-800'
                : 'tw-border-b-transparent hover:tw-border-neutral-400 hover:tw-bg-neutral-100 hover:tw-text-neutral-800'
            )
          "
          (click)="selectTab($event, tab)"
          [attr.aria-controls]="tab.panelId"
          [attr.data-dgat]="tab.id"
          [id]="tab.id"
        >
          <div class="tw-mr-2 tw-size-2">
            @if (
              tab.isHighlighted && configuration().enableHighlightIndicators
            ) {
              <div class="tw-size-2 tw-rounded-full tw-bg-blue-800"></div>
            }
          </div>
          {{ tab.name }}
        </button>
      </li>
    }
  </ul>
</nav>
<div
  [attr.aria-labelledby]="activeTab().id"
  #tabPanel
  role="tabpanel"
  tabindex="-1"
  [class]="{
    'tw-mt-10': true,
    'tw-hidden': !ref.children.length,
  }"
  #ref
>
  <ng-content />
</div>
